import {
  THANK_YOU_PAGE_TYPE_VALUES,
  THANK_YOU_PAGE_TYPE_STRINGS,
} from "features/ThankYouPages/constants/ThankYouPages.constants";

/**
 * Normalizes a page_type value (numeric 1/2, numeric string "1"/"2",
 * or string "purchase"/"optin"/"opt_in") to the canonical numeric
 * THANK_YOU_PAGE_TYPE_VALUES (1 = purchase, 2 = optin).
 * Returns null for null/empty/unknown so callers can decide on fallback.
 * Shared by ThankYouBuilderChoiceModal, list-item card, create-modal and
 * thankyouS3Routes to avoid Number("optin") => NaN drift.
 */
export const normalizeThankYouPageType = (raw) => {
  if (raw == null || raw === "") return null;
  const v = String(raw).toLowerCase().trim();
  if (
    v === String(THANK_YOU_PAGE_TYPE_VALUES.OPTIN) ||
    v === THANK_YOU_PAGE_TYPE_STRINGS.OPTIN ||
    v === THANK_YOU_PAGE_TYPE_STRINGS.OPT_IN
  )
    return THANK_YOU_PAGE_TYPE_VALUES.OPTIN;
  if (
    v === String(THANK_YOU_PAGE_TYPE_VALUES.PURCHASE) ||
    v === THANK_YOU_PAGE_TYPE_STRINGS.PURCHASE
  )
    return THANK_YOU_PAGE_TYPE_VALUES.PURCHASE;
  const n = Number(raw);
  if (
    n === THANK_YOU_PAGE_TYPE_VALUES.PURCHASE ||
    n === THANK_YOU_PAGE_TYPE_VALUES.OPTIN
  )
    return n;
  return null;
};
